import Fab from '@material-ui/core/Fab';
import { darken, withStyles } from '@material-ui/core/styles';

export const BlueFab = withStyles({
    root: {
        backgroundColor: '#1976D2',
        color: '#fff',
        '&:hover': {
            backgroundColor: darken('#1976D2', 0.2),
        },
    },
})(Fab);
export const BlackFab = withStyles({
    root: {
        backgroundColor: '#333',
        color: '#fff',
        '&:hover': {
            backgroundColor: darken('#333', 0.2),
        },
    },
})(Fab);
